import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

const projectNavigationMenuCollapsedTipDismissedKey = 'wasProjectNavigationMenuCollapsedTipDismissedState';
const projectNavigationMenuCollapsedKey = 'isProjectNavigationMenuCollapsedState';
const projectsViewModeStorageKey = 'projectsViewMode';

export type ProjectsViewMode = 'cards' | 'list';

export const isProjectNavigationMenuCollapsedState = atomWithStorage<boolean>(projectNavigationMenuCollapsedKey, false);

export const wasProjectNavigationMenuCollapsedTipDismissedState = atomWithStorage<boolean>(projectNavigationMenuCollapsedTipDismissedKey, false);

export const isProjectNavigationMenuOpenState = atom<boolean>(false);

export const projectsViewModeState = atomWithStorage<ProjectsViewMode>(projectsViewModeStorageKey, 'cards');